/**
 * 导航翻译 - 中文
 * Navigation Translations - Chinese
 */
import { brand } from '@/lib/brand';

export const navZh = {
  // 应用名称
  appName: brand.shortName,
  appFullName: '飞书风格 OA 系统',
  
  // 主导航
  dashboard: '工作台',
  overview: '概览',
  organization: '组织架构',
  approvals: '审批中心',
  automation: '自动化',
  parts: '零件库存',
  formEngine: '表单管理',
  audit: '审计日志',
  logs: '系统日志',
  notifications: '通知中心',
  users: '用户管理',
  
  // 应用组标题
  businessApps: '业务应用',
  systemApps: '系统应用',
  developerTools: '开发工具',
  adminTools: '管理工具',
  
  // 其他
  home: '首页',
  settings: '设置',
  profile: '个人资料',
  logout: '退出登录',
  help: '帮助中心',
  feedback: '意见反馈',
  tickets: '工单系统',
  aiAssistant: 'AI 助手',
  knowledgeBase: '知识库',
  performance: '绩效管理',
  devtracker: '开发管理',
  meetingAttendance: '会议出勤',
  siteAttendance: '考勤打卡',
  syncCenter: '同步中心',
  robotManager: '机器人管理',
  platformMaster: '主数据',
  opsCenter: '运营中心',
  aiUsage: 'AI Coding 用量',
  iamAdmin: '安全治理',
  internalApps: '我的 Apps',

  // Sidebar
  sidebar: {
    expandMenu: '展开菜单',
    collapseMenu: '收起菜单',
    brandName: brand.brandName,
    officeAutomation: '智能办公空间',
  },

  // 反馈子菜单
  feedbackMenu: {
    myFeedback: '我的反馈',
    feedbackManagement: '反馈管理',
  },
};

export type NavTranslations = typeof navZh;
